import React, {useState, useEffect} from 'react'
import { ThemeContext } from '../Context/ThemeContext/ThemeContext'
import UserProfileAside from './UserProfileAside/UserProfileAside'

import './UserProfilePage.css'
import UserPosts from './UserProfilePosts/UserProfilePosts'

const UserProfilePage = () => {
  const { isLight } = React.useContext(ThemeContext)
  return (
    <section className={`user-profile ${isLight ? "" : "dark"}`}>
      <div className="user-profile__container">
        <UserPosts />
        <div className="user-profile__reverse">

        <UserProfileAside />
        </div>
      </div>
    </section>
  )
}

export default UserProfilePage
